import {
  CommissionSettingsCommissionAdjustmentSalePriceReduced,
  ContractSettingsUnconditionalDisplayAs,
  ContractSettingsUnderOfferDisplayAs,
  LicenceDetailsState,
} from '@urbanx/agx.agencies.client';

export interface CommissionSettings {
  commissionAdjustmentSalePriceReduced?: CommissionSettingsCommissionAdjustmentSalePriceReduced;
}

export interface ContractSettings {
  contractsEmail?: string;
  settlementPlace?: string;
  titleEncumbrances?: string;
  underOfferDisplayAs?: ContractSettingsUnderOfferDisplayAs;
  unconditionalDisplayAs?: ContractSettingsUnconditionalDisplayAs;
  buyerEmailParagraph?: CustomEmailParagraph;
  vendorEmailParagraph?: CustomEmailParagraph;
}

export interface ListingAgreementSettings {
  privacyPolicyLink?: string;
  customEmailParagraphs?: CustomEmailParagraph[];
}

export interface CustomEmailParagraph {
  state?: LicenceDetailsState;
  customParagraph?: string;
}

export enum NotificationTemplates {
  ListingAgreementVendorTemplate = 'ListingAgreementVendorTemplate',
  ExecutedContractBuyerTemplate = 'ExecutedContractBuyerTemplate',
  ExecutedContractVendorTemplate = 'ExecutedContractVendorTemplate',
}
